import { db } from "@/firebase/firebaseConfig";
import { useTheme } from "@/utils/theme-context";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useRef, useState } from "react";
import ChatNavigation from "./ChatNavigation";
import MenuIcon from "../UI/MenuIcon";
import { useAuth } from "@/utils/auth-context";
import ChatBody from "./ChatBody";
import AvatarIcon from "../UI/AvatarIcon";
import Sidenav from "../UI/SideNav";

import InvestorModal from "@components/InvestorModal.jsx";

const Chat = () => {
  const [messages, setMessages] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const adminId = "DyNgoxrjL3RtmQZyeeZ60maTo0F2";
  const [loading, setLoading] = useState(false);
  const { user, isVerified } = useAuth();
  const [open, setOpen] = useState(false);
  const [replyTo, setReplyTo] = useState(null);
  const [isVerifiedModal, setIsVerifiedModal] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (!user.uid) return;

    const chatId = selectedUser ? selectedUser.userId : user.uid;
    const messagesRef = collection(db, "chat", chatId, "messages");
    const q = query(messagesRef, orderBy("timestamp"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const fetchedMessages = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessages(fetchedMessages);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user.uid, selectedUser]);

  const { theme } = useTheme();

  const toggleDrawer = (state) => () => {
    setOpen(state);
  };

  const containerRef = useRef(null);

  return (
    <div
      ref={containerRef}
      className={`chat chat--${theme} layout layout--${theme}`}
      onClick={() => setIsVerifiedModal(true)}
    >
      {isVerifiedModal && !isVerified && (
        <InvestorModal
          text={`Доступ временно закрыт`}
          closeModal={() => setIsVerifiedModal(false)}
        />
      )}

      {user.uid === adminId && (
        <Sidenav
          theme={theme}
          setIsOpen={setOpen}
          isOpen={open}
          onClose={toggleDrawer(false)}
        >
          <ChatNavigation
            setLoading={setLoading}
            loading={loading}
            selectedUser={selectedUser}
            onUserSelect={(user) => {
              setSelectedUser(user);
              toggleDrawer(false)();
            }}
          />
        </Sidenav>
      )}

      <div className={`chat-main chat-main--${theme}`}>
        <div className="chat-header">
          {user.uid === adminId && (
            <button
              className="chat-header__button"
              onClick={toggleDrawer(true)}
            >
              <MenuIcon color={`white`} />
            </button>
          )}
          {selectedUser && <AvatarIcon item={selectedUser?.email} />}

          <div className="chat-header-status">
            <h3>{selectedUser ? selectedUser?.email : "Админ"} — Чат</h3>
            {user.uid !== adminId && (
              <ul className="chat-header-status__subtitle">
                <li>Чат работает с 11:00 до 19:00 по времени Казахстана.</li>
                <li>Суббота и воскресенье — выходные.</li>
                <li>
                  Время ожидания ответа — от нескольких минут до нескольких
                  часов.
                </li>
                <li>
                  Чат-поддержка доступна в течение 3 месяцев с момента
                  регистрации на обучающей платформе.
                </li>
                <li>
                  <strong>Важно!</strong> В сообщении подробно опишите вашу
                  проблему и прикрепите скриншоты или видео.
                </li>
              </ul>
            )}
          </div>
        </div>

        <ChatBody
          user={user}
          theme={theme}
          messages={messages}
          loading={loading}
          adminId={adminId}
          selectedUser={selectedUser}
          replyTo={replyTo}
          setReplyTo={setReplyTo}
        ></ChatBody>
      </div>
    </div>
  );
};

export default Chat;
